// @owners { team: patients-team }
import { useCartDeliveryMethods } from '~shared/features/cart/queries/useCartDeliveryMethods';
import {
  getCheckoutPaymentAmountErrors,
  getCheckoutPaymentMethodErrors,
  getPickupPayInAdvanceErrors,
} from '~shared/features/checkout/helpers';
import { getIsOrderPayWithApplePay, getOrder } from '~shared/features/checkout/selectors/getOrder';
import { getOrderIndex } from '~shared/features/checkout/selectors/getOrdersByIndex';
import { getIsSplitPaymentEnabled } from '~shared/features/ui/selectors/getCart';
import { useOrderPricing } from '~shared/queries';
import { useGetPaymentMethods } from '~shared/queries/query-keys/paymentMethods';
import { useSelectorShared } from '~shared/store';

export const useCheckoutPaymentErrors = () => {
  const order = useSelectorShared(getOrder);
  const { isPaymentMethodRequired, orderPricing } = useOrderPricing();
  const { paymentMethods } = useGetPaymentMethods();
  const { deliveryMethods } = useCartDeliveryMethods();
  const orderIndex = useSelectorShared(getOrderIndex);
  const isSplitPaymentEnabled = useSelectorShared(getIsSplitPaymentEnabled);
  const isPaidWithApplePay = useSelectorShared(getIsOrderPayWithApplePay);

  const hasMultipleShipments = deliveryMethods?.length > 1;
  const firstShipmentInSplitPayment = hasMultipleShipments && orderIndex < deliveryMethods.length - 1;

  const { paymentMethodValidationErrors } = isPaidWithApplePay
    ? { paymentMethodValidationErrors: [] }
    : getCheckoutPaymentMethodErrors({
        order,
        paymentMethods,
        isPaymentMethodRequired,
        isSplitPaymentEnabled,
        canIgnore: firstShipmentInSplitPayment,
      });
  const { paymentAmountValidationErrors } = getCheckoutPaymentAmountErrors({
    order,
    isSplitPaymentEnabled,
    splitPaymentsTotal: orderPricing?.subtotal,
    isPaymentMethodRequired,
  });
  const { pickupPayInAdvanceErrors } = getPickupPayInAdvanceErrors({
    order,
    isPaymentMethodRequired,
    canIgnore: isPaidWithApplePay,
  });

  return [...paymentMethodValidationErrors, ...paymentAmountValidationErrors, ...pickupPayInAdvanceErrors];
};
